import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { authService } from '../../services/authService';

const { FiMenu, FiBell, FiUser, FiLogOut, FiChevronDown, FiActivity } = FiIcons;

const Header = ({ setSidebarOpen }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  
  const currentUser = authService.getCurrentUser();

  const handleLogout = async () => {
    if (isLoggingOut) return;
    
    setIsLoggingOut(true);
    try {
      const result = authService.logout();
      if (result.success || !result.success) {
        // Redirect to login page by reloading the app
        window.location.reload();
      }
    } catch (error) {
      console.error('Logout error:', error);
      // Force reload anyway to clear state
      window.location.reload();
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 relative z-50">
      <div className="flex items-center justify-between h-16 px-6">
        <div className="flex items-center">
          <button
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden p-2 rounded-md text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
          >
            <SafeIcon icon={FiMenu} className="h-6 w-6" />
          </button>
          <div className="ml-2 lg:ml-0 flex items-center">
            <div className="h-8 w-8 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-lg flex items-center justify-center mr-3">
              <SafeIcon icon={FiActivity} className="h-5 w-5 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">Best Podiatrist</h1>
              <p className="text-xs text-gray-500 -mt-1">Dr. Amit Kumar C Jain</p>
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full transition-colors">
            <SafeIcon icon={FiBell} className="h-6 w-6" />
          </button>
          
          {/* User Menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="h-8 w-8 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-full flex items-center justify-center">
                <SafeIcon icon={FiUser} className="h-5 w-5 text-white" />
              </div>
              <div className="hidden sm:block text-left">
                <div className="text-sm font-medium text-gray-700">
                  {currentUser?.fullName || 'Admin User'}
                </div>
                <div className="text-xs text-gray-500">
                  {currentUser?.email || 'admin@bestpodiatrist.com'}
                </div>
              </div>
              <SafeIcon 
                icon={FiChevronDown} 
                className={`h-4 w-4 text-gray-500 transition-transform ${
                  showUserMenu ? 'rotate-180' : ''
                }`} 
              />
            </button>

            {/* Dropdown Menu */}
            <AnimatePresence>
              {showUserMenu && (
                <>
                  {/* Backdrop */}
                  <div
                    className="fixed inset-0 z-10"
                    onClick={() => setShowUserMenu(false)}
                  />
                  
                  {/* Menu */}
                  <motion.div
                    initial={{ opacity: 0, scale: 0.95, y: -10 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.95, y: -10 }}
                    transition={{ duration: 0.1 }}
                    className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-20"
                  >
                    <div className="px-4 py-3 border-b border-gray-100">
                      <div className="text-sm font-medium text-gray-900">
                        {currentUser?.fullName || 'Admin User'}
                      </div>
                      <div className="text-sm text-gray-500">
                        {currentUser?.email || 'admin@bestpodiatrist.com'}
                      </div>
                      <div className="text-xs text-blue-600 mt-1">
                        Best Podiatrist Admin
                      </div>
                    </div>
                    
                    <div className="py-1">
                      <button
                        onClick={handleLogout}
                        disabled={isLoggingOut}
                        className="flex items-center w-full px-4 py-2 text-sm text-red-700 hover:bg-red-50 hover:text-red-900 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <SafeIcon icon={FiLogOut} className="mr-3 h-4 w-4" />
                        {isLoggingOut ? 'Logging out...' : 'Logout'}
                      </button>
                    </div>
                  </motion.div>
                </>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;